import React from 'react';
import { motion } from 'framer-motion';
export function ResultsGrid() {
  const results = [{
    title: 'Better Visibility',
    body: 'Understand where your money is actually going with real-time process mapping.'
  }, {
    title: 'Faster Decisions',
    body: 'Know what needs attention before it becomes a bigger problem for your bottom line.'
  }, {
    title: 'Operational Control',
    body: 'Track spending habits, inventory behavior, and business performance across all shifts.'
  }, {
    title: 'Scalability',
    body: 'Create systems that grow with your restaurant, from one location to a national chain.'
  }];
  return <section id="why-roi" className="bg-stark-white py-24 md:py-32 border-b border-gray-100 overflow-hidden" data-id="element-126">
      <div className="max-w-7xl mx-auto px-6" data-id="element-127">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-128">
          {results.map((item, idx) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1,
          ease: 'easeOut'
        }} className="space-y-4" data-id="element-129">
              <h3 className="text-midnight-navy text-xl font-manrope font-bold border-l-4 border-accent-red pl-4" data-id="element-130">
                {item.title}
              </h3>
              <p className="text-midnight-navy/60 leading-relaxed" data-id="element-131">
                {item.body}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}